import { render } from "./OvertimeRequest.vue?vue&type=template&id=05b82f8d"
import script from "./OvertimeRequest.vue?vue&type=script&lang=js"
export * from "./OvertimeRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__